//--------枚举数据-------

//用户类型
const userType = [
    { value: 0, name: "普通用户" },
    { value: 1, name: "医院管理员" },
    { value: 2, name: "科室管理员" }
]

//科室类型
const departmentType = [
    { value: 0, name: "类型一" },
    { value: 1, name: "类型二" },
]

//是否
const isYesOrNo = [
    { value: 0, name: "否" },
    { value: 1, name: "是" },
]

//第三方用户类型
const thirdUserType = [
    { value: "0", name: "只请求内部接口的用户" },
    { value: "1", name: "只能请求外部接口的用户" },
    { value: "2", name: "内部外部接口都可以请求的用户" }
]
//密钥类型
const secretType = [
    { value: "0", name: "密钥类型1" },
    { value: "1", name: "密钥类型2" },
]
const dataBaseType = [
    { value: 0, name: "MySql" },
    { value: 1, name: "SqlServer" },
    { value: 2, name: "Oracle" },
]


const privilegeType = [
    { value: "0", name: "菜单权限" },
    { value: "1", name: "功能权限" },
    // { value: 2, name: "数据权限" },
]


const EmailSendFlag = [
    { value: "0", name: "未发送" },
    { value: "1", name: "已发送" },
    { value: "2", name: "发送失败" }
]

const SendFlag = [
    { value: "0", name: "未发送" },
    { value: "1", name: "已发送" },
    { value: "2", name: "发送失败" },
    { value: "3", name: "不发送" },
]
const clientLogType = [
    { value: "0", name: "硬件" },
    { value: "1", name: "软件" }
]

export default {
    userType,
    departmentType,
    isYesOrNo,
    thirdUserType,
    secretType,
    dataBaseType,
    privilegeType,
    EmailSendFlag,
    SendFlag,
    clientLogType
}

